export default {
  national: "nacional",
  regional: "regional",
  school: "institucional",
  day: "Dia",
  days: "Dias",
  week: "Semana",
  month: "Mês",
  listening: "Escuta",
  speaking: "Fala",
  reading: "Leitura",
  writing: "Escrita",
  points: "Pontos",
  hours: "Horas",
  dismiss: "Fechar",
  close: "Fechar",
  record: "Gravar",
  listen: "Escutar",
  repeat: "Repetir",
  translate: "Traduzir",
  timer: "Tempo",
  next: "Avançar",
  validate: "Validar",
  you: "Eu",
  native: "Nativo",
  checkText: "Verificar o texto",
  congratulations: "Parabéns",
  needHelp: "Precisa de ajuda?",
  instructions: "Instruções",
  continue: "Continuar",
  userSnapButton: "Reportar Erro",
  startIntroductionButton: "Iniciar Introdução",
  preview: "Preview",
  download: "Download",
  open: "Abrir",
  certificationTest: {
    created:
      "Você está apto para fazer o Teste de Certificação. Procure seu professor para fazer o agendamento e enquanto isso, continue revisando o conteúdo do seu curso para se preparar para o teste.",
    scheduled: "Seu Teste de Certificação esta agendado para {scheduledTo} ",
    enabled: "Seu Teste de Certificação está disponível para execução.",
    continue: "Continue seu  Teste de Certificação agora.",
    awaitingRevision:
      "Seu teste de Certificação será avaliado em breve. Você receberá uma notificação em alguns dias com o resultado.",
    reviewed: "Seu Teste de Certificação foi revisado.",
    failed: "Você não atingiu a nota necessária em seu último Teste de Certificação. ",
    button: {
      start: "INICIAR TESTE DE CERTIFICAÇÃO",
      continue: "CONTINUAR TESTE DE CERTIFICAÇÃO",
      reviewed: "VISUALIZAR RESULTADO",
      back: "Voltar para o Curso",
      access: "Entrar",
      accessNewCourse: "Entrar no novo Curso",
    },
    execution: {
      title: "Obtenha uma nota minima de 70 para habilitar o proximo passo que esta bloqueado.",
      completedTitle: "Teste de Certificação finalizado e enviado para revisão.",
      completedDescription:
        "Após o revisão do seu teste pelo avaliador, você recebera uma notificação com a sua nota! \n Boa Sorte!",
      ability: {
        reading: "Teste de Leitura",
        writing: "Teste de Escrita",
        speaking: "Teste de Fala",
        listening: "Teste de Escuta",
      },
      status: {
        finished: "Concluído",
        available: "Iniciar",
        blocked: "Bloqueado",
      },
    },
    result: {
      failedTitle: "Oh não...",
      failedDescription: "Você não atingiu a nota necessária para passar no teste de certificação.",
      failedDescriptionTwo: "Converse com seu professor para entender seus erros e tentar novamente.",
      approvedTitle: "Ótimo!",
      approvedDescription: "Você conseguiu a nota necessária para passar no teste de certificação.",
      approvedDescriptionTwo:
        "Você provou para nós que você aumentou seu nivel de Inglês na escala do Quadro Comum Europeu de Referência para Línguas.",
      scoreBySkill: "Nota por habilidade",
      finalScore: "Nota final",
      unlockedCourse: "Curso desbloqueado",
    },
    help: {
      gotIt: "Ok, entendi",
      free_speak:
        "Neste exercício, diferente da units, você não deve repetir a pergunta apresentada em tela, mas, sim, respondê-la. Você terá até 1 minuto para pensar sobre sua resposta antes que o Gravar se inicie automaticamente. Caso deseje, você também pode iniciar antes.",
      free_speak_image:
        "Neste exercício você devera descrever a imagem apresentada em tela. Você terá até 1 minuto para pensar sobre sua resposta antes que o Gravar se inicie automaticamente. Caso deseje, você também pode iniciar antes.",
    },
  },
  help: {
    DICTATION: "Escute atentamente o áudio do nativo e <b>escreva</b> a frase no campo abaixo.",
    GAP_FILL_MULTIPLE: "Complete a frase <b>arrastando</b> as palavras corretas até os espaços disponíveis.",
    UNSCRAMBLE_DRAG_AND_DROP: "Desembaralhe a frase <b>arrastando</b> as palavras corretas até os espaços disponíveis.",
    PRESENTATION: "Utilize os botões Repetir, Gravar e Escutar para <b>gravar sua voz</b> repetindo o áudio do nativo.",
    PRONUNCIATION: "Utilize o Gravar para <b>falar o texto</b> abaixo.",
    GAP_FILL_SELECT: "Complete a frase <b>selecionando</b> uma das opções disponíveis.",
    SINGLE_CHOICE_AUDIO: "Escute a pergunta e <b>clique</b> na opção correta.",
    SINGLE_CHOICE_TEXT: "Escute a pergunta e <b>clique</b> na opção correta.",
    SINGLE_CHOICE_IMAGE: "Escute a pergunta e <b>clique</b> na opção correta.",
    SPEECH_PRACTICE: "<b>Escute</b> atentamente e utilize o Gravar para <b>repetir</b> o áudio.",
    GAP_FILL: "Grave a frase <b>completa</b> com a opção correta.",
    UNSCRAMBLE_SPEECH_RECOGNITION:
      "Desembaralhe a frase utilizando o botão Gravar para <b>gravar a frase</b> na sequência correta.",
    TEXT: "<b>Leia o texto atentamente</b> e então utilize o botão Avançar para continuar.",
    TRUE_FALSE: "Escute a afirmação e <b>clique</b> em verdadeiro ou falso.",
    PRESENTATION_SPEECHLESS: "Desembaralhe a frase <b>arrastando</b> as palavras corretas até os espaços disponíveis.",
    UNSCRAMBLE_SPEECH_RECOGNITION_SPEECHLESS:
      "Desembaralhe a frase <b>arrastando</b> as palavras corretas até os espaços disponíveis.",
    GAP_FILL_SPEECHLESS: "Complete a frase <b>selecionando</b> uma das opções disponíveis.",
    PRONUNCIATION_SPEECHLESS: "Complete a frase <b>selecionando</b> uma das opções disponíveis.",
    SPEECH_PRACTICE_SPEECHLESS: "Escute atentamente o áudio do nativo e <b>escreva</b> a frase no campo abaixo.",
    VOCABULARY_ACADEMIC_SPEECHLESS:
      "Desembaralhe a frase <b>arrastando</b> as palavras corretas até os espaços disponíveis.",
  },
  items: {
    placeholder: {
      gapFillSelect: "Selecione uma opcão",
      freeSpeak: "Em {time} a gravação iniciará automaticamente. Comece antes se quiser.",
    },
    dictation: {
      errorTitle: "Verifique a lista abaixo para entender os erros na sua frase:",
      moreWordsError: "Sua frase possui {count} palavra(s) a mais.",
      missingWordsError: "Na sua frase faltam {count} palavra(s)",
      wordsWithTyposError: "Palavra(s) com erro(s) na escrita: ",
      wrongWordsError: "Palavra(s) errada(s): ",
    },
    speechRecognition: {
      historyTitle: "Suas tentativas",
      tryAgain: "Tente novamente!",
      errorLowScore: "Nós não conseguimos gerar uma nota para sua fala, por favor tente novamente.",
      errorNoSpeech: "Nós não conseguimos detectar sua fala, por favor tente novamente.",
    },
  },
  intro: {
    next: "Avançar",
    previous: "Voltar",
    skip: "Pular",
    done: "Concluir",
    gotIt: "Entendi",
    steps: {
      gapFillSelect: "Selecione uma das opções para completar a frase.",
      singleChoiceImage: "Ouça o áudio e selecione a imagem correspondente.",
      singleChoiceText: "Ouça o áudio e selecione o item correspondente.",
      singleChoiceAudio: "Ouça o áudio e selecione uma das opções correspondente.",
      gapFill1: "O texto está incompleto. É necessário completá-lo com uma das opções.",
      gapFill2: "Clique e selecione uma das opções.",
      unscrambleDragDrop1: "Aqui será necessário desembaralhar a frase a partir das opções disponíveis.",
      unscrambleDragDrop2: "Estas são as opções. Arraste os itens para montar o texto!",
      gapFillMultiple1: "O texto está incompleto. É necessário completá-lo com as opções corretas.",
      gapFillMultiple2: "Estas são as opções. Arraste os itens para montar o texto!",
      controlBar1: "Botão para repetir o áudio. Lembre-se que só poderá ser usado uma vez!",
      controlBar2:
        "Tempo máximo para cada questão. Lembrando que ele inicia a contagem após alguns segundos depois do carregamento do exercício.",
    },
  },
  login: {
    email: "E-mail",
    password: "Senha",
    enter: "Entrar",
    forgotPassword: "Esqueci minha senha",
    forgotPasswordDescription: "Informe seu e-mail no campo abaixo e nós iremos enviar um e-mail com a sua nova senha.",
    forgotPasswordPostDescription: "Você pode alterar a nova senha na sua pagina de atualizar perfil.",
    backToLogin: "Voltar ao login",
    resetPassword: "Enviar nova senha",
    resetPasswordSuccess: "Sua nova senha foi enviada por e-mail.",
    ssoOnlyDescription:
      "Acesse <a href='{url}' style='color: blue; text-decoration: underline'>{url}</a> para realizar o login na plataforma",
    unexpected_error: "Não foi possível realizar o login. Tente novamente em alguns instantes.",
    email_not_found: "E-mail não encontrado.",
    user_not_found_in_distributor: "E-mail não encontrado.",
    user_not_found_in_company: "E-mail não encontrado.",
    invalid_password: "Senha invalída.",
    classroom_not_found: "Seu usuário não está associado a uma sala.",
    inactive_classroom: "Sala em período inativo.",
    user_with_placement_in_classroom: "Você já concluiu seu Teste de Nivelamento.",
    user_disabled: "Seu usuário esta desabilitado, verifique com sua instituição.",
    payment_required: "Existe um pagamento em aberto. Verifique seu e-mail ou entre em contato conosco.",
    limit_reached: "Todas as contas disponíveis já foram utilizadas.",
    student_contract_blocked:
      "Ops, parece que seu acesso foi bloqueado. Entre em contato com seu professor para mais informações.",
  },
  error: {
    required: "Obrigatório",
    invalidEmail: "E-mail invalído",
    differentPasswords: "As senhas não são iguais",
    audioDownload: "Ocorreu um problema para tocar o áudio. Tente novamente usando o botão Repetir.",
    noSpeechDetected:
      "Não foi possível detectar sua fala. Verifique seu microfone, ele pode estar mudo ou configurado com uma sensibilidade muito baixa. Tente escutar sua gravação para verificar o áudio.",
    generalConnectionError: "Foi detectado uma instabilidade de conexão. Por favor, tente novamente este exercício.",
    generateUnitScore: "Ocorreu um problema para gerar sua nota.",
    emailPasswordInvalid: "Verifique seu email e/ou senha.",
    emailNotFound: "Não encotramos nenhum usuário para o e-mail informado.",
    duplicatedEmail: "Já existe um usuário com o e-mail informado.",
    updateProfileError: "Ocorreu um problema para atualizar seu perfil.",
    updateAvatarError: "Ocorreu um problema para atualizar seu avatar.",
    checkBrowserType: {
      title: "Desculpe, o browser que você esta utilizando não é suportado.",
      description1:
        "Para uma boa experiência em nossa plataforma considere a utilização da última versão do Google Chrome web browser.",
      description2: "Você também pode utilizar o Mozila Firefox ou Safari.",
    },
    checkBrowserVersion: {
      title: "Seu browser esta desatualizado.",
      description:
        "Para uma boa experiência em nossa plataforma considere a utilização da última versão. Faça o download da ultima versão neste {link}.",
    },
    checkAudioPermission: {
      title: "Quase lá",
      description:
        'Desculpe, nós detectamos que você está usando o <b style="textTransform: capitalize">{browserName}</b> web browser e que nossa plataforma não possui permissão para reproduzir automaticamente os áudios.',
      safari: {
        description: "Sigua os passos abaixo para habilitar a reprodução dos áudios:",
        step1: "Clique com o botão direito na barra de endereços e selecione a opção: <b>Ajuste para este Site</b>",
        step2: "Na opcão Reprodução Automática, selecione: <b>Permitir todas as reproduçoes automáticas</b>",
        step3: "Recarregue a pagina e você estara pronto para começar",
      },
      chrome: {
        description: "Clique no botão abaixo para permitir e continuar.",
        button: "Permitir e continuar",
      },
    },
    error_play_audio: "Ocorreu um problema para tocar o áudio do nativo. Tente utilizar o repetir novamente",
    error_play_record: "Ocorreu um problema para tocar sua gravação. Tente utilizar o listen novamente",
    error_start_record: "Ocorreu um problema para acessar seu microfone. Tente utilizar o gravar novamente",
    error_stop_record: "Ocorreu um problema para finalizar sua gravação. Tente utilizar o gravar novamente",
    error_find_speech_recognition_text:
      "Ocorreu um problema para definir a resposta. Tente utilizar o gravar novamente",
    error_get_speech_recognition_score: "Ocorreu um problema para definir sua nota. Tente gravar novamente",
    error_no_speech: "Não conseguimos detectar sua fala. Tente gravar novamente",
    error_word_alignment: "A frase está incompleta. Tente gravar novamente.",
    error_save_answer: "Ocorreu um problema para salvar sua resposta. Tente confirmar a resposta novamente",
    error_inspect_html: "Não é permitido inspecionar o site. O progresso dessa unit será perdido.",
    error_record_not_allowed:
      "A plataforma não teve permissão para acessar seu microfone. Verifique as permissões do seu navegador.",
    error_record_missing_mic: "Não foi possível acessar seu microfone. Verifique as configurações do seu navegador.",
    three_minute_block:
      "Você acabou de completar o exercício. É preciso esperar 3 minutos para refazê-lo. Favor faça outro exercício enquanto isso.",
    error_browser_block_autoplay: "Clique no botão abaixo para continuar a atividade.",
    error_browser_block_intro_autoplay: "Vamos começar? Clique no botão abaixo e siga as instruções.",
    error_reply_ct_speak: "Parece que você repetiu a frase ao invés de responde-la. Grave sua resposta novamente.",
    high_inactive_time: "Parece que você ficou inativo por um longo período.",
  },
  payment: {
    pendingPayment:
      "Você possui um pagamento em aberto com vencimento em {date}. <a href='{link}' target='_blank' style='color: blue; text-decoration: underline'>Clique aqui</a> para realizar o pagamento agora.",
  },
  requireDesktop: {
    title: "Ops! Algo deu errado",
    desktopRequiredCard: {
      title: "Você precisa usar um computador",
      description:
        "Utilize um computador para realizar seu teste de certificação. Através de um computador você terá uma experiencia melhor para realizar seu teste com tranquilidade",
    },
  },
};
